export default "__VITE_ASSET__kapb0Exf__"